import React from "react";

const OnboardingSSl = () => {
  return (
    <>
      <div className="marginBody flex gap-8">
        <div className="flex flex-wrap md:flex-nowrap">
          <div>
            <p className="text-[10px] text-[#adabab] mb-2">
              By completing the form above, each of the above listed business
              and business owner/officer (individually and collectively, “you”)
              authorize GFN Capital and each of its representatives, successors,
              assigns and designees (“Recipients”) that may be involved with or
              acquire commercial loans having daily repayment features or
              purchases of future receivables including GFN Capital Advance
              transactions, including without limitation the application
              therefor (collectively, “Transactions”) to obtain consumer or
              personal, business and investigative reports and other information
              about you, including credit card processor statements and bank
              statements, from one or more consumer reporting agencies, such as
              TransUnion, Experian and Equifax, and from other credit bureaus,
              banks, creditors and other third parties.
            </p>
            <p className="text-[10px] text-[#adabab] mb-2">
              You authorize GFN Capital to transmit this application form, along
              with any of the foregoing information obtained in connection with
              this application, to any or all of the Recipients for the
              foregoing purposes. You also consent to the release, by any
              creditor or financial institution, of any information relating to
              any of you, to GFN Capital and to each of the Recipients, on its
              own behalf.”
            </p>
            <p className="text-[10px] text-[#adabab] mb-2">
              In Addition, you expressly consent to receiving marketing and
              other calls and messages, to land line, wireless or similar
              devices, including auto dialed and pre-recorded message calls, and
              SMS messages (including text messages) from Recipients, at
              telephone numbers that you have provided. Message and data rates
              may apply. Your consent to receive marketing calls is not required
              for your application; if you do not consent do not provide cell
              phone number.
            </p>
          </div>
          <div>
            <div>
              <img src="/assets/images/SSL.png" className="w-[764px]" alt="ssl"/>
              <p className="text-[10px] text-[#adabab] mb-2 font-bold mt-4">
                Site Secure
              </p>
              <p className="text-[10px] text-[#adabab] mb-2">
                We use bank-level security to keep your data safe.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="marginBody">
        <div>
          <p className="text-[10px] text-black">
            Copyright © 2023 All Rights Reserved by GFN Capital •Terms of Use
            •Privacy Policy • Call: 404-920-4946 • 90 Broad St, New York, NY
            10004
          </p>
        </div>
      </div>
    </>
  );
};

export default OnboardingSSl;
